/*
 * @Author: zyy
 * @Date: 2022-04-01 10:08:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-02-21 12:40:00
 * @Description: default
 */
import Axios from "axios";
import Qs from 'qs'
export default {
    // 添加分类
    add(pid, name, remarks) {
        return Axios.post('/community/api/admin/tsjy/category/add', {
            pid, name, remarks
        })
    },
    // 编辑分类
    edit(id, name, remarks) {
        return Axios.post(`/community/api/admin/tsjy/category/update/${id}`, {
            name, remarks
        })
    },
    // 删除
    delete(id) {
        return Axios.post(`/community/api/admin/tsjy/category/delete/${id}`)
    },
    // 更改状态
    status(id) {
        return Axios.post(`/community/api/admin/tsjy/category/setStatus/${id}`)
    },
    // 分类列表
    list(name, page) {
        return Axios.get('/community/api/admin/tsjy/category/list', {
            params: {
                page,
                name
            },
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },

}